import type { App } from "vue"
import router from "@/router"
import * as Sentry from "@sentry/vue"
import { wasmIntegration } from "@sentry/wasm"

export default {
  install(app: App) {
    return Sentry.init({
      app,
      release: `ks-ui-web@${__VERSION__}:ks-engine@${__ENGINE_VERSION__}`,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
      integrations: [
        wasmIntegration(),
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration()
      ],
      // Tracing
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [/^\/api\//],
      // Session Replay
      // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })
  }
}
